import { Modal } from "antd";
import React from "react";

export const ModalDelete = ({
  visible,
  open,
  title = "Confirmar exclusão",
  message = "Deseja realmente excluir este registro?",
  onCancel,
  onConfirm,
  confirmLoading = false,
  okText = "Excluir",
  cancelText = "Cancelar",
  okButtonProps,
  cancelButtonProps,
  width,
  centered = true,
  destroyOnClose = true,
  children,
  ...rest
}) => (
  <Modal
    title={title}
    visible={visible ?? open}
    onCancel={onCancel}
    onOk={onConfirm}
    confirmLoading={confirmLoading}
    okText={okText}
    cancelText={cancelText}
    okButtonProps={{ danger: true, ...okButtonProps }}
    cancelButtonProps={cancelButtonProps}
    width={width}
    centered={centered}
    destroyOnClose={destroyOnClose}
    {...rest}
  >
    {children ?? (
      <p style={{ margin: 0, fontSize: 16, fontWeight: 500 }}>{message}</p>
    )}
  </Modal>
);

